export default __webpack_public_path__ + "static/ananas-83912fe4cf5862081a83c9b6159673f7.webp";